module.exports = __webpack_public_path__ + "images/800x800_Individual_0000s_0011_SUSO_bubble.png";